module.exports = __webpack_public_path__ + "static/img/6d.ab2b6fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6d.jpg
// module id = Oe/Z
// module chunks = 1